import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {withRouter} from 'react-router-dom'
import {withBoundary} from 'Components/ErrorBoundary'
import DocumentTitle from 'react-document-title'
import {Spin} from 'antd'
import Form from './Form'
import Controls from './Controls'

import style from './style.sass'

@withBoundary
@withRouter
@inject('store') @observer
class Builder extends Component {
  state = {
    additionalFields: false
  }
  componentDidMount() {
    this.loadAlgo()
    this.loadStockFilters()
    this.checkPermission()
  }
  componentDidUpdate(prevProps) {
    if(this.props.match.params.algoID !== prevProps.match.params.algoID) {
      this.loadAlgo()
    }
  }
  async loadAlgo() {
    const {algoID} = this.props.match.params
    if(algoID) {
      await this.props.store.algo.single.load(algoID)
      if (this.props.store.algo.single.additional_signal.text) {
        this.showAdditional()
      } else {
        this.hideAdditional()
      }
    } else {
      this.props.store.algo.single.blank()
      this.hideAdditional()
    }
  }
  showAdditional = () => {
    this.setState({additionalFields: true})
  }
  hideAdditional = () => {
    this.setState({additionalFields: false})
  }
  async loadStockFilters() {
    const query = this.props.location.query
    await this.props.store.stockFilter.list.load()
    if (query?.stock_filter) {
      this.props.store.algo.single.selectStockFilter(+query.stock_filter)
    }
  }
  async checkPermission() {
    const {permissions} = this.props.store
    await permissions.loadSingle('lab.algo.create')
    if (!this.props.match.params.algoID) {
      if (!window.location.pathname.endsWith('/builder') || window.location.pathname.endsWith('stock-filters/builder')) {
        return
      }
      permissions.wrap('lab.algo.create', null, false)
    }
  }
  render() {
    const {algo} = this.props.store
    const {data} = algo.single
    const {algoID} = this.props.match.params
    const editing = !!algoID
    return(
      <div styleName='wrapper'>
        <DocumentTitle title='Algo Builder'/>

        <Spin size='large' spinning={algo.single.loading || algo.preparingBacktest}>
          <Form showAdditional={this.showAdditional} additionalFields={this.state.additionalFields}/>
          <Controls editing={editing}/>
        </Spin>
        {!data.is_paper_trading_on &&
          <iframe
            width='320'
            height='240'
            frameBorder='0'
            className='embed-responsive-item'
            src='https://www.youtube.com/embed/H0ZN5gVc-os'
            allowFullScreen
          />
        }
      </div>
    )
  }
}

export default Builder
